export default __webpack_public_path__ + "static/media/sweets-1.79a694ad.jpeg";